import CryptoJS from 'crypto-js';

const key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_HTTP_ENCRYPT_VERSION_SECRETKEY);
const iv = CryptoJS.enc.Hex.parse(
  import.meta.env.VITE_HTTP_ENCRYPT_VERSION_SECRETKEY.slice(0, 32)
);

export const encryptedData = (data: string) => {
  return CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
};

export const decryptedData = (data: string) => {
  return CryptoJS.AES.decrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};
